export const DateFormats = {
    FULL_SHORT_MONTH: 'd M yy',
    SHORT_SIMPLE: 'd/m/yy',
    MONTH: 'mm/yy',
    DAY_MONTH: 'D MMM',
    DAY_MONTH_PADDED: 'DD MMM',
    DAY_MONTH_NUMERIC: 'D/M',
    DAY_MONTH_NUMERIC_YEAR: 'D/M/YY',
    FULL_DAY_MONTH_YEAR: 'DD MMM YYYY',
    SHORT_MONTH: 'MMM',
    SHORT_MONTH_YEAR: 'MMM YYYY',
    YEAR_FULL: 'YYYY',
    TIME_SIMPLE: 'HH:mm',
    DAY_MONTH_HOUR_MINUTE: 'D MMM HH:mm',
    COMPACT_DAY_MONTH: 'D/M',
    COMPACT_DAY_MONTH_YEAR: 'D/M/YY',
    COMPACT_MONTH_YEAR: 'M/YY',
};
